import { render, staticRenderFns } from "./DependentMarriageVisa.vue?vue&type=template&id=3531bd20&"
import script from "./DependentMarriageVisa.vue?vue&type=script&lang=js&"
export * from "./DependentMarriageVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports